import React from 'react'
import { createUseStyles } from 'react-jss'
import { colors } from '../../../theme/palette'
import { Note } from '../../../assets/icons'

interface Props {
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const useStyles = createUseStyles(() => ({
    note: {
        width: '53px',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        textDecoration: 'none',
        transition: 'all 0.2s',
        boxShadow: 0,
        border: '0',
        background: 'none',
        '&:hover': {
            cursor: 'pointer',
        },
        '-webkit-appearance': 'none',
        '-moz-appearance': 'none',
    },
    noteText: {
        position: 'absolute',
        color: colors.green500,
        fontSize: '14px',
        // top: '8px',
        // left: '23px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
}))

const NoteButton: React.FC<Props> = ({ onClick, children }) => {
    const classes = useStyles()

    return (
        <button type="button" onClick={onClick} className={classes.note}>
            <Note width="28px" color="rgba(41, 122, 113, 0.4)" />
            <span className={classes.noteText}>{children}</span>
        </button>
    )
}

export { NoteButton }
